'use strict';

module.exports = {
  DOCUMENT_VISIBILITY_CHANGE_EVENT_DELAY: 500,
  PROCESS_RESULTS_DELAY: 1000,
  VENMO_OPEN_URL: 'https://venmo.com/braintree/checkout'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/venmo/shared/constants.js
// module id = 364
// module chunks = 0